import { ConfigOption } from '@ngx-formly/core';
import { DatepickerFieldTypeComponent } from './datepicker-field-type/datepicker-field-type.component';
import { DatetimepickerFieldTypeComponent } from './datetimepicker-field-type/datetimepicker-field-type.component';
import { emailValidator } from './email-validator';
import { fieldMatchValidator } from './field-match-validator';
import { FormlyHorizontalWrapperComponent } from './formly-horizontal-wrapper/formly-horizontal-wrapper.component';

export function applyDefaultOptions(field) {
  if (field.key && !field.modelOptions) {
    field.modelOptions = {
      debounce: { default: 500 }
    };
  }
}

export class FormlyConfig {
  static getConfig(): ConfigOption {
    return {
      extensions: [
        { name: 'defaultOptions', extension: { prePopulate: applyDefaultOptions } }
      ],
      types: [
        {
          name: 'datepicker',
          component: DatepickerFieldTypeComponent,
          wrappers: ['form-field']
        },
        {
          name: 'datetimepicker',
          component: DatetimepickerFieldTypeComponent,
          wrappers: ['form-field']
        }
      ],
      validators: [
        { name: 'fieldMatch', validation: fieldMatchValidator },
        { name: 'email', validation: emailValidator },
      ],
      validationMessages: [
        { name: 'required', message: 'Pole wymagane' }
      ],
      wrappers: [{ name: 'form-field-horizontal', component: FormlyHorizontalWrapperComponent }],
    }
  }
}
